import { CapacitorCookies } from '@capacitor/core';
import type { CookieHandlerInterface } from 'supertokens-web-js/lib/build/cookieHandler/types';

export default function getCookieHandler(original: CookieHandlerInterface): CookieHandlerInterface {
  return {
    ...original,
    getCookie: async (): Promise<string> => {
      const flow = localStorage.getItem('FLOW');
      const cookies = document.cookie.replaceAll(`${flow}-`, '');
      return decodeURIComponent(cookies);
    },
    setCookie: async (cookieString: string): Promise<void> => {
      const flow = localStorage.getItem('FLOW');
      const parts = cookieString.split(';').map((part) => part.trim());
      const [nameValue, ...attributes] = parts;
      const [key, value] = nameValue.split('=');

      const httpCookie: {
        key: string;
        value: string;
        expires?: string;
        path?: string;
        sameSite?: 'lax' | 'strict' | 'none';
      } = { key: flow ? `${flow}-${key}` : key, value };

      attributes.forEach((attribute) => {
        const [attrKey, attrVal] = attribute.split('=');
        const normalizedKey = attrKey.toLowerCase();

        switch (normalizedKey) {
          case 'expires':
            httpCookie.expires = attrVal;
            break;
          case 'path':
            httpCookie.path = attrVal;
            break;
          case 'samesite':
            httpCookie.sameSite = attrVal.toLowerCase() as 'lax' | 'strict' | 'none';
            break;
        }
      });

      await CapacitorCookies.setCookie(httpCookie);
    },
  };
}
